import { Box, Grid, Modal } from "@mui/material";
import { useState } from "react";

export default function ProductImages({ images = [] }) {
    const [mainImage, setMainImage] = useState(images[0] || 'https://inovartgold.com.br/assets/general-images/product-placeholder.jpg');
    const [isModalOpen, setIsModalOpen] = useState(false);

    const isImagesArray = Array.isArray(images) && images.length > 1;

    const styles = {
        container: {
            display: "flex",
            justifyContent: "left",
        },
        thumbnails: {
            display: "flex",
            flexDirection: "column",
            paddingRight: "1rem",
        },
        thumbnailImage: {
            marginBottom: "0.5rem",
            cursor: "pointer",
            borderRadius: 1,
            width: '25%'
        },
        mainImage: {
            cursor: "pointer",
            borderRadius: 1,
            width: isImagesArray? '75%' : '100%'
        },
    };

    return (
        <>
            <Modal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Box
                    component="img"
                    src={mainImage}
                    alt="Foto do produto"
                    sx={{ maxHeight: "90%", maxWidth: "90%" }}
                />
            </Modal>

            <Grid size={{ xs: 12, md: 6 }} sx={styles.container}>
                {isImagesArray && (
                    <Box sx={styles.thumbnails}>
                        {images.map((image) => (
                            <Box
                                key={image}
                                component="img"
                                src={image}
                                alt="Miniatura do produto"
                                sx={styles.thumbnailImage}
                                onClick={() => setMainImage(image)}
                            />
                        ))}
                    </Box>
                )}
                <Box
                    component="img"
                    onClick={() => setIsModalOpen(true)}
                    src={mainImage}
                    alt="Foto do produto"
                    sx={styles.mainImage}
                />
            </Grid>
        </>
    );
};